import { Seo } from "@/components/Seo";
import { PublicNavbar } from "@/components/public/PublicNavbar";
import { PublicFooter } from "@/components/public/PublicFooter";
import { WhatsAppFab } from "@/components/public/WhatsAppFab";
import { ContactForm } from "@/components/public/PublicFooter";
import { waLink } from "@/lib/site";
import { WhatsappLogo } from "@phosphor-icons/react";

const PAGES = {
  hakkimizda: {
    title: "Hakkımızda",
    path: "/hakkimizda",
    blocks: [
      { h: null, p: "AI Marka Radar, işletmelerin yapay zekâ asistanlarındaki görünürlüğünü ölçmek ve yönetmek için kurulmuş bir AEO/GEO platformudur. Amacımız basit: müşteriler ChatGPT, Gemini ve Perplexity'ye soru sorduğunda markanızın önerilip önerilmediğini net biçimde göstermek." },
      { h: "Neden kurulduk?", p: "Arama alışkanlıkları hızla değişiyor. Klasik arama motorlarının yerini giderek yapay zekâ asistanları alıyor ve bu asistanlar tek bir cevap veriyor. Bu cevapta yer almak, işletmeler için yeni bir görünürlük savaşı anlamına geliyor. Biz bu savaşta işletmelere pusula oluyoruz." },
      { h: "Ne yapıyoruz?", p: "Sektörünüze özel gerçek müşteri sorularını üç büyük yapay zekâ sağlayıcısına birden çok kez sorar, markanızın anılma oranını ve sıralamasını ölçer, rakiplerinizle karşılaştırır ve yapay zekânın güvendiği kaynakları listeleriz. Böylece nereye odaklanmanız gerektiğini görürsünüz." },
      { h: "Dürüstlük ilkemiz", p: "Hiçbir firma yapay zekâ cevaplarını garanti edemez. Biz sonuç garantisi satmıyoruz; ölçüm, şeffaflık ve görünürlüğünüzü artıracak somut çalışmalar sunuyoruz." },
    ],
  },
  iletisim: {
    title: "İletişim",
    path: "/iletisim",
    blocks: [
      { h: null, p: "Sorularınız, iş birlikleri ve teklif talepleri için bize ulaşın. En hızlı yanıt için WhatsApp'ı kullanabilir ya da aşağıdaki formu doldurabilirsiniz; ekibimiz sizi arasın." },
    ],
    showContact: true,
  },
  gizlilik: {
    title: "Gizlilik Politikası",
    path: "/gizlilik",
    blocks: [
      { h: null, p: "Bu Gizlilik Politikası, AI Marka Radar'ı kullanırken kişisel verilerinizin nasıl toplandığını, işlendiğini ve korunduğunu açıklar." },
      { h: "Topladığımız veriler", p: "Hesap oluştururken Google hesabınızdan ad ve e-posta bilgisi; rapor oluştururken girdiğiniz marka, sektör ve rakip bilgileri; iletişim formunu doldurduğunuzda ad, telefon ve mesaj bilgileriniz toplanır." },
      { h: "Verilerin kullanımı", p: "Verileriniz yalnızca hizmeti sunmak, raporlarınızı üretmek ve talebiniz üzerine sizinle iletişime geçmek için kullanılır. Verileriniz üçüncü taraflara pazarlama amacıyla satılmaz." },
      { h: "Üçüncü taraf servisler", p: "Raporları üretmek için yapay zekâ sağlayıcılarının (OpenAI, Google, Perplexity) API'leri kullanılır. Bu servislere yalnızca rapor için gerekli soru metinleri iletilir." },
      { h: "Haklarınız", p: "Verilerinizin silinmesini veya düzeltilmesini talep edebilirsiniz. Bunun için iletişim kanallarımızdan bize ulaşabilirsiniz." },
    ],
  },
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    path: "/kvkk",
    blocks: [
      { h: null, p: "6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında, veri sorumlusu olarak kişisel verilerinizin işlenmesine ilişkin sizi bilgilendirmek isteriz." },
      { h: "İşlenen kişisel veriler", p: "Kimlik ve iletişim bilgileriniz (ad, e-posta, telefon) ile hizmet kullanımına ilişkin bilgiler (oluşturduğunuz raporlar, girdiğiniz marka/sektör bilgileri) işlenmektedir." },
      { h: "İşleme amaçları", p: "Verileriniz; hizmetin sunulması, raporların üretilmesi, talebiniz üzerine iletişim kurulması ve yasal yükümlülüklerin yerine getirilmesi amacıyla işlenir." },
      { h: "Hukuki sebep", p: "Verileriniz, sözleşmenin ifası ve meşru menfaat hukuki sebeplerine dayanılarak, açık rızanızın gerektiği hâllerde ise rızanıza istinaden işlenir." },
      { h: "Haklarınız", p: "KVKK'nın 11. maddesi uyarınca; verilerinize erişme, düzeltilmesini veya silinmesini isteme ve işlenmesine itiraz etme haklarına sahipsiniz. Taleplerinizi iletişim kanallarımız üzerinden iletebilirsiniz." },
    ],
  },
};

export default function LegalPage({ page }) {
  const data = PAGES[page];
  if (!data) return null;
  return (
    <div className="bg-background min-h-screen">
      <Seo title={`${data.title} — AI Marka Radar`} description={data.blocks[0].p.slice(0, 150)} path={data.path} />
      <PublicNavbar />
      <WhatsAppFab />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">{data.title}</h1>
        <div className="mt-8 space-y-6">
          {data.blocks.map((b, i) => (
            <div key={i}>
              {b.h && <h2 className="font-heading text-xl font-semibold tracking-tight mb-2">{b.h}</h2>}
              <p className="text-foreground/85 leading-relaxed text-[17px]">{b.p}</p>
            </div>
          ))}
        </div>
        {data.showContact && (
          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            <a href={waLink()} target="_blank" rel="noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-medium py-3">
              <WhatsappLogo size={20} weight="fill" /> WhatsApp'tan Yazın
            </a>
            <div className="sm:col-span-2 border border-border p-6">
              <h2 className="font-heading font-semibold text-lg mb-4">İletişim Formu</h2>
              <ContactForm />
            </div>
          </div>
        )}
      </main>
      <PublicFooter />
    </div>
  );
}
